import VerticalBar from './VerticalBar.component';

export default VerticalBar;
